import { CSSResultGroup, html, TemplateResult } from 'lit';
import componentStyles from './idb-recommendation-tag.css.lit';

import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * The IDB Recommendation Tag component.
 * @element idb-recommendation-tag
 * @extends OutlineElement
 * @slot recommendation-tag - slot for tag text
 * @property tag background - Color of the tag background.
 */
export type TagBackgrounds = 'yellow' | 'green' | 'orange' | 'blue';
@customElement('idb-recommendation-tag')
export class IdbRecommendationTag extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Let's you set the title weight.
   */
  @property({ type: String, attribute: 'tag-background', reflect: true })
  tagBackground: TagBackgrounds = 'yellow';

  render(): TemplateResult {
    return html`
      <div class="recommendation-tag">
        <slot name="recommendation-tag"></slot>
      </div>
    `;
  }
}
